import { createReducer } from 'utils/reducerUtils';
import {
	GET_BUYING_GUIDE_REQUEST,
	GET_BUYING_GUIDE_SUCCESS,
	GET_BUYING_GUIDE_ERROR
} from 'actions/buyingGuidesActions';

// this will be map of buying guides with keys as categories.
const INITIAL_STATE = {};

export default createReducer(GET_BUYING_GUIDE_REQUEST, GET_BUYING_GUIDE_SUCCESS, GET_BUYING_GUIDE_ERROR, INITIAL_STATE);
